import { createFileRoute } from "@tanstack/react-router";

import ComponentsPage from "@/app/design-system/components/ComponentsPage";

export const Route = createFileRoute("/admin/design-system/components")({
  component: ComponentsPage,
});
